import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import ReactMarkdown from 'react-markdown';
import rehypeSlug from 'rehype-slug';
// eslint-disable-next-line max-len
import markdown from '../data/staticPages/i/sustainability-certification-organizations-in-fashion.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Hero from '../components/Hero';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const SustainabilityCertificationOrganizationsInFashionPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'sustainability-certification-organizations-in-fashion',
    'sustainabilityCertificationOrganizationsInFashion',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
        description={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
        )}
        title={intl.formatMessage(
          messages['sustainabilityCertificationOrganizationsInFashion.title'],
        )}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

SustainabilityCertificationOrganizationsInFashionPage.getLayout = (
  page: ReactElement,
) => (
  <Layout
    header={(
      <Hero alt="Sustainability Certification Organization banner image" />
    )}
  >
    {page}
  </Layout>
);

SustainabilityCertificationOrganizationsInFashionPage
  .getInitialProps = redirectRouteToDomain(
    'sustainability-certification-organizations-in-fashion',
  );

export default SustainabilityCertificationOrganizationsInFashionPage;
